import createIcon from '../../createIcon';

/**
 * @component @name RequestQuote
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDIwQzQgMjEuMSA0Ljg5IDIyIDUuOTkgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTUgMTJIMTFWMTNIMTRDMTQuNTUgMTMgMTUgMTMuNDUgMTUgMTRWMTdDMTUgMTcuNTUgMTQuNTUgMTggMTQgMThIMTNWMTlIMTFWMThIOVYxNkgxM1YxNUgxMEM5LjQ1IDE1IDkgMTQuNTUgOSAxNFYxMUM5IDEwLjQ1IDkuNDUgMTAgMTAgMTBIMTFWOUgxM1YxMEgxNVYxMlpNMTMgOFYzLjVMMTcuNSA4SDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RequestQuote = createIcon('RequestQuote', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15 12H11V13H14C14.55 13 15 13.45 15 14V17C15 17.55 14.55 18 14 18H13V19H11V18H9V16H13V15H10C9.45 15 9 14.55 9 14V11C9 10.45 9.45 10 10 10H11V9H13V10H15V12ZM13 8V3.5L17.5 8H13Z',
      key: 'ocejrj',
    },
  ],
]);

export default RequestQuote;
